/* eslint-disable */
const pageActualites = document.querySelector('body.template-actualites');
const pageMetiers = document.querySelector('body.template-metiers');

function resetChanges(posts, filters) {
  posts.forEach(post => { post.style.display = "block"; })
  filters.forEach(item => {
    if (item.classList.contains('is_active')) {
      item.classList.remove('is_active');
    }
  })
}

function changeIconOrientation() {
  const fTitleBis = document.querySelectorAll('.f-title-bis');
  fTitleBis.forEach(el => el.onclick = function () {
    [this.querySelector('.arrow-down'),
    this.querySelector('.arrow-top'),
    this.parentNode.querySelector('ul.f-content')].forEach(el => el.classList.toggle('clicked'))
  })
}

if (pageActualites || pageMetiers) {

  const filterLinks = document.querySelectorAll('.cpt-filters ul > li > a');
  const postPreviews = document.querySelectorAll('.cpt-wrapper > .inner-cpt-wrapper > .cpt-preview');

  filterLinks.forEach(filter => {
    filter.onclick = function () {
      resetChanges(postPreviews, filterLinks);
      this.classList.add('is_active');
      if (this.dataset.category != 'all') {
        postPreviews.forEach(post => {
          if (post.dataset.category != this.dataset.category) {
            post.style.display = 'none';
          }
        })
      }
    }
  })

  changeIconOrientation();

}


const pageOffresEmploi = document.querySelector('body.template-offres');

if (pageOffresEmploi) {
  const filters1 = document.querySelectorAll('.cpt-filters >.f-1 > ul.f-content > li > a');
  const filters2 = document.querySelectorAll('.cpt-filters >.f-2 > ul.f-content > li > a');
  const filtersAll = document.querySelectorAll('.cpt-filters ul.f-content > li > a');
  const jobPreviews = document.querySelectorAll('.cpt-wrapper > .inner-cpt-wrapper > .cpt-preview');


  filters1.forEach(filter => {
    filter.onclick = function () {
      resetChanges(jobPreviews, filtersAll);
      this.classList.add('is_active');
      console.log(this);
      if (this.dataset.category != "all") {
        jobPreviews.forEach(post => {
          if (post.dataset.category != this.dataset.category) {
            post.style.display = 'none';
          }
        })
      }
    }
  })
  filters2.forEach(filter => {
    filter.onclick = function () {
      resetChanges(jobPreviews, filtersAll);
      this.classList.add('is_active');
      console.log(this);
      if (this.dataset.type != "all") {
        jobPreviews.forEach(post => {
          if (post.dataset.type != this.dataset.type) {
            post.style.display = 'none';
          }
        })
      }
    }
  })

  changeIconOrientation();
}


// WEBPACK FOOTER //
// ./scripts/actualites-offres.js